import React from 'react'
import axios from 'axios'
import moment from 'moment'
import { Grid, Table, Panel, Label } from 'react-bootstrap'

const baseUrl = '/api/reports'

const fmt = ms => (ms === null || ms === undefined ? '—' : `${Math.round(ms).toLocaleString('nl-NL')} ms`)

function coverageLabel(report) {
  if (!report.complete) {
    return <Label bsStyle="warning">Partieel — {report.incompleteReason}</Label>
  }

  if (!report.final) {
    const upTo = moment.utc(report.window.to).subtract(1, 'day').format('YYYY-MM-DD')

    return <Label bsStyle="info">Lopend, bijgewerkt tot en met {upTo}</Label>
  }

  return <Label bsStyle="default">Definitief</Label>
}

function slaLabel(report) {
  if (!report.sla || report.sla.length === 0) {
    return null
  }

  const pass = report.sla.every(target => target.pass)

  return <Label bsStyle={pass ? 'success' : 'danger'}>{pass ? 'Binnen SLA' : 'SLA overschreden'}</Label>
}

function ReportRow({ report, onSelect }) {
  return (
    <tr onClick={() => onSelect(report.month)} style={{ cursor: 'pointer' }}>
      <td>{report.month}</td>
      <td>{coverageLabel(report)}</td>
      <td className="text-right">{report.volume.totalRequests.toLocaleString('nl-NL')}</td>
      <td className="text-right">{report.latency ? fmt(report.latency.p95) : '—'}</td>
      <td className="text-right">{report.latency ? fmt(report.latency.p99) : '—'}</td>
      <td>{slaLabel(report)}</td>
    </tr>
  )
}

class Reports extends React.Component {
  state = {
    reports: [],
    error: false,
  }

  componentDidMount() {
    this.fetchReports()
  }

  fetchReports = () => {
    const { isAuthenticated, getAccessToken } = this.props.auth

    if (!isAuthenticated()) {
      return
    }

    const headers = { Authorization: `Bearer ${getAccessToken()}` }

    axios({ url: baseUrl, method: 'GET', headers })
      .then(response => this.setState({ reports: response.data, error: false }))
      .catch(error => this.setState({ reports: [], error }))
  }

  onSelect = month => this.props.history.push(`/reports/${month}`)

  render() {
    const { reports } = this.state

    return (
      <Grid fluid>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Performance-rapportage (trace)</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Maand</th>
                  <th>Dekking</th>
                  <th className="text-right">Requests</th>
                  <th className="text-right">P95</th>
                  <th className="text-right">P99</th>
                  <th>SLA</th>
                </tr>
              </thead>
              <tbody>
                {reports.map(report => (
                  <ReportRow key={report.month} report={report} onSelect={this.onSelect} />
                ))}
              </tbody>
            </Table>
          </Panel.Body>
        </Panel>
      </Grid>
    )
  }
}

export default Reports
